<template>
  <div class="report-template">
    <div class="report-header">
      <h1 class="report-title textMainColor">{{ $t('Transaction History') }}</h1>
      <div class="report-account-type-list">
        <div
            class="report-account-type-item"
            :class="accountType === 'FUTURE' ? 'active' : ''"
        >
          <a
            @click="changeAccountType('FUTURE')"
          >{{$t('Futures Account')}}</a>
        </div>
        <div
            class="report-account-type-item"
            :class="accountType === 'SPOT' ? 'active' : ''"
        >
          <a
            @click="changeAccountType('SPOT')"
          >{{$t('Spot Account')}}</a>
        </div>
      </div>
    </div>
    <div class="report-info">
      <div class="report-filter-wrapper">
        <div class="report-filter-item">
          <div class="report-filter-item-title">{{ $t('Date') }}</div>
          <div class="report-filter-item-input-wrap">
            <date-picker
                v-model="dateRange"
                :disabled-date="disabledRange"
                :editable="false"
                :format="'DD/MM/YYYY'"
                :input-class="$vuetify.theme.dark ? 'theme-dark' : 'theme-light'"
                :lang="$i18n.locale"
                :placeholder="$t('Date Range')"
                :popup-class="$vuetify.theme.dark ? 'theme-dark' : 'theme-light'"
                :range-separator="' - '"
                range
            ></date-picker>
          </div>
        </div>
        <div class="report-filter-item">
          <div class="report-filter-item-title">{{ $t('tradingAssets') }}</div>
          <div class="report-filter-item-input-wrap">
            <CustomSelect
                ref="selectAssets"
                :options="assetsOptionsList"
                custom-class="support-form"
                default="All"
                @update:modelValue="formData.asset = $event"
            />
          </div>
        </div>
        <div class="report-filter-item">
          <div class="report-filter-item-title">{{ $t('type') }}</div>
          <div class="report-filter-item-input-wrap">
            <CustomSelect
                ref="selectType"
                :options="accountType === 'FUTURE' ? typeOptionsList : typeOptionsListSpot"
                custom-class="support-form"
                default="All"
                @update:modelValue="formData.type = $event"
            />
          </div>
        </div>
        <!--      <div class="report-filter-item">-->
        <!--        <div class="report-filter-item-title">{{ $t('Search') }}</div>-->
        <!--        <div class="search-input-wrap">-->
        <!--          <input-->
        <!--              id="search"-->
        <!--              v-model="formData.searchedText"-->
        <!--              v-debounce:1000ms="changeSelectFilter"-->
        <!--              :placeholder="$t('Search')"-->
        <!--              class="search-input"-->
        <!--              name="search-result"-->
        <!--              type="search"-->
        <!--          >-->
        <!--          <div class="search-icon search">-->
        <!--            <svg-->
        <!--                fill="none"-->
        <!--                height="16"-->
        <!--                viewBox="0 0 16 16"-->
        <!--                width="16"-->
        <!--                xmlns="http://www.w3.org/2000/svg"-->
        <!--            >-->
        <!--              <path-->
        <!--                  d="M7.33334 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33334C12.6667 4.38782 10.2789 2 7.33334 2C4.38782 2 2 4.38782 2 7.33334C2 10.2789 4.38782 12.6667 7.33334 12.6667Z"-->
        <!--                  stroke="#42E8E0"-->
        <!--                  stroke-linecap="round"-->
        <!--                  stroke-linejoin="round"-->
        <!--                  stroke-width="1.5"-->
        <!--              />-->
        <!--              <path-->
        <!--                  d="M13.9996 13.9996L11.0996 11.0996"-->
        <!--                  stroke="#42E8E0"-->
        <!--                  stroke-linecap="round"-->
        <!--                  stroke-linejoin="round"-->
        <!--                  stroke-width="1.5"-->
        <!--              />-->
        <!--            </svg>-->
        <!--          </div>-->
        <!--          <div-->
        <!--              v-if="formData.searchedText.length"-->
        <!--              class="search-icon reset"-->
        <!--              @click.stop="resetQuestion"-->
        <!--          >-->
        <!--            <svg-->
        <!--                fill="none"-->
        <!--                height="16"-->
        <!--                viewBox="0 0 16 16"-->
        <!--                width="16"-->
        <!--                xmlns="http://www.w3.org/2000/svg"-->
        <!--            >-->
        <!--              <path-->
        <!--                  d="M2.25 2.25L7.99995 7.99995M7.99995 7.99995L13.7499 2.25M7.99995 7.99995L13.75 13.7498M7.99995 7.99995L2.2501 13.7498"-->
        <!--                  stroke="#E9E9E9"-->
        <!--                  stroke-linecap="round"-->
        <!--                  stroke-linejoin="round"-->
        <!--                  stroke-width="1.5"-->
        <!--              />-->
        <!--            </svg>-->
        <!--          </div>-->
        <!--        </div>-->
        <!--      </div>-->
        <div class="report-filter-button-wrap">
          <button @click="resetFilterParams">{{ $t('Reset') }}</button>
        </div>
      </div>
    </div>
    <div class="report-content">
      <div class="preloader new-preloader" v-if="isLoading">
        <lottie-animation
            ref="preloader"
            :animationData="require('@/assets/img/Loader.json')"
            :loop="true"
            :autoPlay="true"
            :speed="1"
        />
      </div>
      <table v-if="tradingTableInfoTransactionOrders.value.size" class="transaction-orders-table">
        <thead class="holder-table">
          <tr class="table-head">
          <!-- 1 -->
          <th class="pair">
            <p>
              <span class="textSecondaryColor">{{ $t('Asset') }}</span>
            </p>
          </th>
          <th class="amount">
            <p>
              <span class="textSecondaryColor">{{ $t('amount') }}</span>
            </p>
          </th>
          <th class="type">
            <p>
              <span class="textSecondaryColor">{{ $t('type') }}</span>
            </p>
          </th>
          <th class="time">
            <p>
              <span class="textSecondaryColor">{{ $t('time') }}</span>
            </p>
          </th>
            <th class="status">
              <p>
                <span class="textSecondaryColor">{{ $t('Status') }}</span>
              </p>
            </th>
            <th class="scan">
            <p>
              <span class="textSecondaryColor">{{ $t('Explorer') }}</span>
            </p>
          </th>
        </tr>
        </thead>
        <tbody class="open-orders-table-main">
          <TradingOrderTransactionItems
              v-for="(transactionOrdersItems, index) in transactionHistory"
              :id="transactionOrdersItems"
              :key="index"
              :historyOrdersItems="transactionOrdersItems[1]"
              :isCheckedOrders="isCheckedOrders"
          />
        </tbody>
      </table>
      <div v-if="!isLoading && isDataEmpty" class="holder-not-logged-text report-empty-wrap">
        <div class="report-empty-list">
          <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M42.1351 5.89334C41.0418 4.8 39.1484 5.54667 39.1484 7.06667V16.3733C39.1484 20.2667 42.4551 23.4933 46.4818 23.4933C49.0151 23.52 52.5351 23.52 55.5484 23.52C57.0684 23.52 57.8684 21.7333 56.8018 20.6667C52.9618 16.8 46.0818 9.84 42.1351 5.89334Z" fill="#92939C"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M46.9613 27.1733H54.668C56.1346 27.1733 57.3346 28.3733 57.3346 29.84V39.6441C55.2687 38.1884 52.7495 37.3333 50.0315 37.3333C43.0218 37.3333 37.3346 43.0205 37.3346 50.0302C37.3346 53.365 38.6218 56.4005 40.7262 58.6666H21.5213C13.308 58.6666 6.66797 53.3333 6.66797 43.8133V20.1866C6.66797 10.6666 13.308 5.33331 21.5213 5.33331H32.828C34.2946 5.33331 35.4946 6.53331 35.4946 7.99998V15.7066C35.4946 22.0266 40.6413 27.1733 46.9613 27.1733ZM57.3346 43.755V43.8133C57.3346 52.1992 52.1825 57.3365 45.3411 58.4415C42.3948 56.7941 40.4015 53.6436 40.4015 50.0302C40.4015 44.7143 44.7156 40.4002 50.0315 40.4002C52.9509 40.4002 55.5682 41.7013 57.3346 43.755ZM20.0013 47.3333H30.668C31.7613 47.3333 32.668 46.4266 32.668 45.3333C32.668 44.24 31.7613 43.3333 30.668 43.3333H20.0013C18.908 43.3333 18.0013 44.24 18.0013 45.3333C18.0013 46.4266 18.908 47.3333 20.0013 47.3333ZM20.0013 36.6666H36.0013C37.0946 36.6666 38.0013 35.76 38.0013 34.6666C38.0013 33.5733 37.0946 32.6666 36.0013 32.6666H20.0013C18.908 32.6666 18.0013 33.5733 18.0013 34.6666C18.0013 35.76 18.908 36.6666 20.0013 36.6666Z" fill="#92939C"/>
            <path d="M59.9855 57.2476L58.0636 55.3257C59.0655 53.8127 59.6584 51.993 59.6584 50.0302C59.6584 44.7143 55.3443 40.4002 50.0284 40.4002C44.7125 40.4002 40.3984 44.7143 40.3984 50.0302C40.3984 55.3461 44.7125 59.6602 50.0284 59.6602C51.9912 59.6602 53.7905 59.0672 55.3239 58.0654L57.2458 59.9873C57.6343 60.3758 58.125 60.5598 58.6361 60.5598C59.1473 60.5598 59.638 60.3758 60.0264 59.9873C60.742 59.2513 60.742 58.0245 59.9855 57.2476Z" fill="#92939C"/>
          </svg>
          <p class="secondary-text holder-not-logged-text">{{ $t('No records found') }}</p>
        </div>
      </div>
      <div class="table-footer" v-if="tradingTableInfoTransactionOrders.value.size">
        <div class="report-download">
          <div
              class="report-download-link"
              @click="openExportPopup"
          >
            <svg
                fill="none"
                height="16"
                viewBox="0 0 17 16"
                width="17"
                xmlns="http://www.w3.org/2000/svg"
            >
              <path
                  clip-rule="evenodd"
                  d="M9.73633 2C9.73633 1.58579 9.40054 1.25 8.98633 1.25C8.57211 1.25 8.23633 1.58579 8.23633 2V8.18934L6.18328 6.1363C5.89039 5.8434 5.41552 5.8434 5.12262 6.1363C4.82973 6.42919 4.82973 6.90406 5.12262 7.19696L8.4558 10.5301C8.59154 10.666 8.77912 10.75 8.98633 10.75C9.19679 10.75 9.38701 10.6633 9.52322 10.5237L12.85 7.19696C13.1428 6.90406 13.1428 6.42919 12.85 6.1363C12.5571 5.8434 12.0822 5.8434 11.7893 6.1363L9.73633 8.18926V2ZM2.98633 9.25C3.40054 9.25 3.73633 9.58579 3.73633 10V12.6667C3.73633 12.8214 3.79779 12.9697 3.90718 13.0791C4.01658 13.1885 4.16495 13.25 4.31966 13.25H13.653C13.8077 13.25 13.9561 13.1885 14.0655 13.0791C14.1749 12.9697 14.2363 12.8214 14.2363 12.6667V10C14.2363 9.58579 14.5721 9.25 14.9863 9.25C15.4005 9.25 15.7363 9.58579 15.7363 10V12.6667C15.7363 13.2192 15.5168 13.7491 15.1261 14.1398C14.7354 14.5305 14.2055 14.75 13.653 14.75H4.31966C3.76713 14.75 3.23722 14.5305 2.84652 14.1398C2.45582 13.7491 2.23633 13.2192 2.23633 12.6667V10C2.23633 9.58579 2.57211 9.25 2.98633 9.25Z"
                  fill="white"
                  fill-rule="evenodd"
              />
            </svg>
            <span>{{ $t('Export Transaction History') }}</span>
          </div>
        </div>
        <b-pagination-nav
            v-if="!isLoading && tradingTableInfoTransactionOrders.value.size && count !== 1"
            v-model="page"
            :link-gen="linkGen"
            :number-of-pages="count"
            :per-page="pageSize"
            :total-rows="count"
            class="pagination"
            first-number
            last-number
            next-text="»"
            prev-text="«"
            use-router
        />
      </div>
    </div>
    <ExportHistoryPopup
        ref="exportPopups"
        :periodList="periodList"
        v-if="!isLoading && tradingTableInfoTransactionOrders.value.size"
        :popup-title="$t('Export Transaction History')"
        :form-data="formData"
        @exportForm="getTransactionHistory"
    />
  </div>
</template>
<script>
// import DatePicker from 'vue2-datepicker';
import LottieAnimation from "lottie-web-vue";
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/ru';
import 'vue2-datepicker/locale/hi';
import 'vue2-datepicker/locale/es';
import 'vue2-datepicker/locale/zh-cn';
import TradingOrderTransactionItems from './transaction-history/TradingOrderTransactionItems';
// import CustomSelect from '../inputs/CustomSelect';
// import ExportHistoryPopup from '../popups/ExportHistoryPopup';
import { mapActions } from 'vuex';
import {authHeader} from "@/helpers";
import {useReactiveMap} from "vue-reactive-collection";

export default {
  name: 'ReportsOrderHistory',
  data() {
    return {
      isCheckedOrders: false,
      assetsOptionsList: [
        {
          name: 'All',
          value: '',
        },
        {
          name: 'DXLN',
          value: 'dxln',
        },
        {
          name: 'USDT',
          value: 'usdt',
        },
      ],
      typeOptionsList: [
        {
          name: 'All',
          value: '',
        },
        {
          name: 'Fee',
          value: 'FEE',
        },
        {
          name: 'Funding fee',
          value: 'FUNDING_FEE',
        },
        {
          name: 'Withdraw',
          value: 'WITHDRAW',
        },
        {
          name: 'Deposit',
          value: 'DEPOSIT',
        },
        {
          name: 'Realized pl',
          value: 'REALIZED_PL',
        },
      ],
      typeOptionsListSpot: [
        {
          name: 'All',
          value: '',
        },
        {
          name: 'Withdraw',
          value: 'WITHDRAW',
        },
        {
          name: 'Deposit',
          value: 'DEPOSIT',
        },
        {
          name: 'Transfer to spot',
          value: 'TRANSFER_TO_SPOT',
        },
        {
          name: 'Transfer to future',
          value: 'TRANSFER_TO_FUTURE',
        },
        {
          name: 'Reward',
          value: 'REWARD',
        },
        // {
        //   name: 'Liquidation fee',
        //   value: 'LIQUIDATION_FEE',
        // },
        // {
        //   name: 'Realized pl',
        //   value: 'REALIZED_PL',
        // },
        // {
        //   name: 'Funding fee',
        //   value: 'FUNDING_FEE',
        // },
        // {
        //   name: 'Fee',
        //   value: 'FEE',
        // },

        // DEPOSIT, WITHDRAW, FEE, FUNDING_FEE, REALIZED_PL, LIQUIDATION_FEE, TRANSFER_TO_SPOT, TRANSFER_TO_FUTURE, REWARD
      ],
      periodList: [
        {
          name: 'Last 24 hours',
          val: 'LAST_24_HOURS',
        },
        {
          name: 'Yesterday',
          val: 'YESTERDAY',
        },
        {
          name: 'Last 2 weeks',
          val: 'LAST_2_WEEKS',
        },
        {
          name: 'Past month',
          val: 'PAST_MONTH',
        },
        {
          name: 'Past 3 months',
          val: 'PAST_3_MONTHS',
        },
        {
          name: 'Month to date',
          val: 'MOUNT_TO_DATE',
        },
      ],
      tradingTableInfoTransactionOrders: [],
      walletAddress: null,
      counters: {},
      dateRange: [new Date(new Date().getTime() - 604800000), new Date()],
      formData: {
        asset: '',
        searchedText: '',
        type: '',
      },
      page: 1,
      pageSize: 20,
      count: 2,
      accountType: 'FUTURE',
      isLoading: true,
      isDataEmpty: false,
    };
  },
  computed: {
    transactionHistory() {
      return this.$store.getters["reports/getTransactionHistory"]
    },
  },
  watch: {
    'dateRange'(value) {
      this.formData.dateFrom = isNaN(Date.parse(this.dateRange[0])) == false ? (String(Date.parse(this.dateRange[0])) / 1000) : '';
      this.formData.dateTo = isNaN(Date.parse(this.dateRange[1])) == false ? (String(Date.parse(this.dateRange[1]) + 86400000) / 1000) : '';
      if(value.length) {
        this.changeSelectFilter();
      }
    },
    'formData.asset'() {
      this.changeSelectFilter();
    },
    'formData.type'() {
      this.changeSelectFilter();
    },
    '$route.query': {
      deep: true,
      handler(newVal) {
        if(newVal) {
          this.page = newVal.page;
          this.getOpenOrdersData();
        } else {
          this.page = 1;
          this.accountType = 'FUTURE'
        }
      },
    },
    tradingTableInfoTransactionOrders: {
      deep: true,
      handler(newValue, oldValue) {
        this.$store.commit('reports/SET_TRANSACTION_HISTORY', this.tradingTableInfoTransactionOrders.value)
      }
    },
  },
  methods: {
    ...mapActions({
      getOrdersReportTransactions: 'reports/getOrdersReportTransactions',
      getTransactionHistoryData: 'reports/getTransactionHistory',
    }),
    disabledRange: function (date) {
      return date > new Date();
    },
    linkGen(pageNum) {
      return {
        path: '/reports/transaction-history',
        query: { page: +pageNum },
      };
    },
    openExportPopup() {
      this.$refs.exportPopups.openPopups();
    },
    resetPagination() {
      this.$router.push({path: '/reports/transaction-history', query: { page: 1, type: this.accountType }}).catch(() => {});
    },
    changeSelectFilter() {
      this.resetPagination()
      if(this.page === 1) {
        this.getOpenOrdersData();
      }
    },
    resetQuestion() {
      this.formData.searchedText = '';
      this.getOpenOrdersData();
    },
    resetFilterParams() {
      this.dateRange = [];
      this.formData.dateFrom = '';
      this.formData.dateTo = '';
      this.formData.asset = '';
      this.formData.type = '';
      this.formData.searchedText = '';
      this.resetPagination()
      if(this.page === 1) {
        this.getOpenOrdersData();
      }
      this.resetFilterToDefault();
    },
    resetFilterToDefault() {
      this.$refs.selectAssets.reset();
      this.$refs.selectType.reset();
    },
    onDeleteTradingOrder(order) {
      this.infoDialogData = {
        dialogTitle: `Cancel ${ order.length ? 'Orders' : 'Order' }`,
        dialogText: `Are you sure you want to cancel ${ order.length ? order.length + ' Orders' : 'Order' }?`,
        confirmBtnText: 'Yes',
        cancelBtnText: 'No',
      };

      this.$refs.infoDialog.showDialog(order);
    },
    onDeleteTradingOrderAll() {
      this.infoDialogData = {
        dialogTitle: `Cancel Orders`,
        dialogText: `Are you sure you want to cancel Orders?`,
        confirmBtnText: 'Yes',
        cancelBtnText: 'No',
      };

      this.$refs.infoDialogDeleteOrderAll.showDialog();
    },
    getTransactionHistory(params) {
      this.getTransactionHistoryData({ params }).then(res => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'report.csv');
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link)
        this.isLoading = false;
      });
    },
    getRequestParams(formData) {
      const params = {};

      for (const data in formData) {
        if(formData[data]) {
          params[data] = formData[data];
        }
      }

      return params;
    },

    changeAccountType(type) {
      if(type === this.accountType) {
        return
      }
      this.accountType = type
      this.$router.push({path: '/reports/transaction-history', query: { page: 1, type: this.accountType }}).catch(() => {});
    },

    getPendingStatuses() {
      const requestOptions = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      };

      const arr = [...this.tradingTableInfoTransactionOrders.value].map((item) => item[1].transactionUuid)

      const params = arr.splice(',')

      fetch(`${process.env.VUE_APP_BLOCKCHAIN_API_URL}/api/v1/transactions/pending-statues/${params}`, requestOptions)
          .then((response) => response.body)
          .then((rb) => {
            const reader = rb.getReader();
            return new ReadableStream({
              start(controller) {
                function push() {
                  reader.read().then(({ done, value }) => {
                    if (done) {
                      controller.close();
                      return;
                    }
                    controller.enqueue(value);
                    push();
                  });
                }
                push();
              },
            });
          })
          .then((stream) =>
              new Response(stream, { headers: { 'Content-Type': 'text/html' } }).text()
          )
          .then((result) => {
            let data = JSON.parse(result);
            if(data.result && data.result.length) {
              data.result.sort((a, b) => a.id - b.id);
              data.result.forEach((item) => {
                this.tradingTableInfoTransactionOrders.value.set(item.uuid, {
                  ...this.tradingTableInfoTransactionOrders.value.get(item.uuid),
                  status: item.type
                })
              })
              this.$store.commit('reports/SET_TRANSACTION_HISTORY', this.tradingTableInfoTransactionOrders.value)
            }
          });
    },

    getOpenOrdersData() {
      this.tradingTableInfoTransactionOrders.value.clear()
      this.isLoading = true;
      this.isDataEmpty = false;

      const params = this.getRequestParams(this.formData)
      params.size = this.pageSize
      params.page = this.page - 1
      params.accountType = this.accountType

      this.getOrdersReportTransactions({params}).then((data) => {
        let content = data.content

        content.forEach((historyItem) => {
          if(this.accountType === 'FUTURE') {
            const randomNumber = Math.floor(Math.random() * 10000) + 1;
            this.tradingTableInfoTransactionOrders.value.set(+historyItem.transactionId + +randomNumber, {
              ...historyItem,
              accountType: this.accountType
            })
          }else {
            this.tradingTableInfoTransactionOrders.value.set(historyItem.transactionUuid, {
              ...historyItem,
              accountType: this.accountType
            })
          }
        })

        if(this.accountType === 'SPOT') {
          if(this.tradingTableInfoTransactionOrders.value.size) {
            this.getPendingStatuses()
          }
        }

        this.$store.commit('reports/SET_TRANSACTION_HISTORY', this.tradingTableInfoTransactionOrders.value)

        this.counters.tradingTableInfoTransactionOrders = 0;
        this.count = data.totalPages
        this.isLoading = false;
        if(!this.tradingTableInfoTransactionOrders.value.size) {
          this.isDataEmpty = true;
        }
      });
    },
  },
  created() {
    this.tradingTableInfoTransactionOrders = useReactiveMap(new Map())
  },
  mounted() {
    this.page = +this.$route.query.page || 1;
    this.getOpenOrdersData();
  },
  components: {
    LottieAnimation,
    DatePicker: () => import('vue2-datepicker'),
    CustomSelect: () => import('../inputs/CustomSelect'),
    ExportHistoryPopup: () => import('../popups/ExportHistoryPopup'),
    // TradingOrderTransactionItems: () => import('./transaction-history/TradingOrderTransactionItems'),
    TradingOrderTransactionItems,
  },
};
</script>
<style lang="scss">

.v-application.theme--dark .report-download {
  flex-wrap: wrap;
  justify-content: flex-end;
  cursor: initial;
  width: auto;
}

.v-application.theme--dark .report-download {
  text-decoration: none;
}

.v-application.theme--dark .report-download:hover {
  color: #A4A5AF !important;
}

.v-application.theme--dark .report-download:hover svg path {
  fill: #A4A5AF !important;
}

.report-download-link {
  width: 100%;
  margin-left: auto;
  margin-right: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  cursor: pointer;
  transition: all .5s;
}

.v-application.theme--dark .report-download-link:hover svg path {
  fill: #42E8E0 !important;
}

.v-application.theme--dark .report-download-link:hover {
  color: #42E8E0 !important;
}

.v-application a.report-wallet-address {
  color: var(--v-accent-base);
  text-decoration: none;
  display: inline-block;
  margin-top: 10px;
}

.v-application a.report-wallet-address:hover {
  text-decoration: underline;
}

.report-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.report-filter-wrapper {
  width: 100%;
}

.table-body td {
  padding: 6px 0;
}

.report-account-type-list {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  border: 1px solid #02C9BF;
  border-radius: 6px;
}

.report-account-type-item {
  background: rgba(66, 232, 224, 0.24);
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 14px 19px;
}

.report-account-type-item.active {
  background: #1BB8B0;
}

.report-account-type-item a {
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
  text-align: center;
  color: #EBEBF0 !important;
}

.transaction-orders-table {
  width: 100%;

  p {
    margin-bottom: 0;
    padding: 12px 0;
    text-align: left;
  }

  .up {
    top: 4px;
    left: 0;
  }

  .down {
    bottom: 4px;
    left: 0;
  }

  .pair {
    width: 10%;
  }

  .amount {
    width: 30%;
    padding-right: 10%;
    text-align: right;
  }

  .type {
    width: 25%;
    padding-left: 5%;
    text-align: left;
  }

  .time {
    width: 20%;
    padding-left: 50px;
    text-align: left;
  }

  .status {
    width: 20%;
    padding-left: 50px;
    text-align: left;
  }

  .scan {
    width: 5%;
    //padding-left: 10%;
    text-align: right;
    p {
      text-align: right;
      padding-right: 25px;
    }
  }

  .table-head {
    .status p {
      text-align: right;
    }

    .price p {
      text-align: right;
    }

    .filled p {
      text-align: right;
    }

    .status p {
      text-align: left;
    }

    .amount p {
      text-align: right;
    }

    .side p {
      text-align: center;
    }

    .time p {
      text-align: left;
    }
  }
}

.table-body:nth-child(even) {
  background: rgba(70, 70, 70, 0.2);
}

@media (max-width: 1500px) {
  .report-info {
    flex-wrap: wrap;
  }

  .report-filter-wrapper {
    width: 100%;
  }

  .report-download {
    justify-content: flex-start;
    margin-top: 30px;
  }

  .report-download-link {
    justify-content: flex-start;
  }
}
</style>
